import React, { useState, useEffect } from 'react';
import './TiltMode.css';

const TiltMode = () => {
  const [isActive, setIsActive] = useState(false);
  const [videoPreloaded, setVideoPreloaded] = useState(false);
  
  // Détecter si c'est un appareil mobile pour optimiser les performances
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  const showImpact = () => {
    setIsActive(true);
    
    // Vérifier si la vidéo est préchargée
    if (!videoPreloaded) {
      console.warn('Vidéo pas encore préchargée, attente...');
      // Attendre un peu et réessayer
      setTimeout(() => showImpact(), 100);
      return;
    }
    
    // Récupérer tous les éléments et les faire vibrer avec des animations différentes
    const headerElements = document.querySelectorAll('.profile-header');
    const cardElements = document.querySelectorAll('.card');
    const textElements = document.querySelectorAll('.profile-name, .profile-desc, .card-content h2, .card-content p');
    
    // Désactiver les animations sur iOS pour éviter les bugs
    if (isIOS) {
      console.log('iOS détecté - animations désactivées pour éviter les bugs');
      // Sur iOS, on fait juste un effet de flash simple
      headerElements.forEach(el => {
        el.style.transition = 'opacity 0.1s';
        el.style.opacity = '0.7';
      });
      
      cardElements.forEach(el => {
        el.style.transition = 'opacity 0.1s';
        el.style.opacity = '0.8';
      });
      
      textElements.forEach(el => {
        el.style.transition = 'opacity 0.1s';
        el.style.opacity = '0.6';
      });
    } else {
      // Optimiser les animations selon l'appareil (non-iOS)
      const animationDuration = isMobile ? '0.12s' : '0.08s';
      const cardDuration = isMobile ? '0.10s' : '0.06s';
      const textDuration = isMobile ? '0.08s' : '0.04s';
      
      // Header - vibration plus intense
      headerElements.forEach(el => {
        el.style.animation = `vibrateHeader ${animationDuration} infinite`;
        el.style.transformOrigin = 'center';
      });
      
      // Cards - vibration modérée
      cardElements.forEach(el => {
        el.style.animation = `vibrateCards ${cardDuration} infinite`;
        el.style.transformOrigin = 'center';
      });
      
      // Textes - vibration plus douce
      textElements.forEach(el => {
        el.style.animation = `vibrateText ${textDuration} infinite`;
        el.style.transformOrigin = 'center';
      });
    }
    
    // Afficher la vidéo (déjà préchargée)
    const brokenScreen = document.createElement('div');
    brokenScreen.className = 'broken-screen';
    
    // Sur iOS, utiliser une image statique au lieu de la vidéo pour éviter les bugs
    if (isIOS) {
      brokenScreen.innerHTML = `
        <div class="broken-screen-static" style="
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(45deg, #ff0000, #00ff00, #0000ff);
          opacity: 0.8;
          z-index: 9999;
          animation: flash 0.5s ease-in-out;
        "></div>
      `;
    } else {
      brokenScreen.innerHTML = `
        <video autoplay playsinline ${isMobile ? 'poster=""' : ''}>
          <source src="/glass.webm" type="video/webm">
        </video>
      `;
    }
    
    document.body.appendChild(brokenScreen);
    
    // La vidéo est déjà préchargée, donc elle devrait jouer immédiatement (seulement sur non-iOS)
    if (!isIOS) {
      const videoElement = brokenScreen.querySelector('video');
      
      // Forcer le démarrage immédiat
      videoElement.play().catch(e => {
        console.warn('Impossible de jouer la vidéo préchargée:', e);
        if (brokenScreen.parentNode) {
          brokenScreen.parentNode.removeChild(brokenScreen);
        }
      });
    }

    // Arrêter les effets après 1 seconde
    setTimeout(() => {
      if (isIOS) {
        // Sur iOS, restaurer l'opacité normale
        [...headerElements, ...cardElements, ...textElements].forEach(el => {
          el.style.opacity = '1';
        });
      } else {
        // Sur les autres appareils, arrêter les animations
        [...headerElements, ...cardElements, ...textElements].forEach(el => {
          el.style.animation = 'none';
        });
      }
    }, 1000);

    // Relancer des effets plus faibles après 1.5 secondes (seulement sur non-iOS)
    if (!isIOS) {
      setTimeout(() => {
        // Header - vibration plus faible
        headerElements.forEach(el => {
          el.style.animation = 'vibrateHeaderWeak 0.12s infinite';
          el.style.transformOrigin = 'center';
        });
        
        // Cards - vibration plus faible
        cardElements.forEach(el => {
          el.style.animation = 'vibrateCardsWeak 0.10s infinite';
          el.style.transformOrigin = 'center';
        });
        
        // Textes - vibration plus faible
        textElements.forEach(el => {
          el.style.animation = 'vibrateTextWeak 0.08s infinite';
          el.style.transformOrigin = 'center';
        });
      }, 1500);
    }

    // Arrêter complètement après 4 secondes
    setTimeout(() => {
      const brokenScreen = document.querySelector('.broken-screen');
      if (brokenScreen && brokenScreen.parentNode) {
        // Arrêter la vidéo avant de la supprimer
        const video = brokenScreen.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
        brokenScreen.parentNode.removeChild(brokenScreen);
      }
      
      // Arrêter tous les effets
      [...headerElements, ...cardElements, ...textElements].forEach(el => {
        el.style.animation = 'none';
        el.style.transform = 'none';
        el.style.opacity = '1';
        el.style.transition = 'none';
      });
      
      // Nettoyer les références
      setIsActive(false);
      
      window.location.reload();
    }, 10000);
  };

  // Précharger la vidéo au montage du composant
  useEffect(() => {
    const preloadVideo = () => {
      const video = document.createElement('video');
      video.preload = 'auto';
      video.src = '/glass.webm';
      video.muted = true;
      video.playsInline = true;
      
      video.addEventListener('canplaythrough', () => {
        console.log('Vidéo préchargée avec succès');
        setVideoPreloaded(true);
      });
      
      video.addEventListener('error', () => {
        console.warn('Erreur de préchargement de la vidéo');
        setVideoPreloaded(false);
      });
      
      // Forcer le chargement
      video.load();
    };
    
    preloadVideo();
  }, []);

  // Nettoyer les effets au démontage
  useEffect(() => {
    return () => {
      const brokenScreen = document.querySelector('.broken-screen');
      if (brokenScreen && brokenScreen.parentNode) {
        brokenScreen.parentNode.removeChild(brokenScreen);
      }
    };
  }, []);

  return (
    <>
      <button 
        className={`tilt-mode-btn ${isActive ? 'active' : ''}`}
        onClick={showImpact}
        disabled={!videoPreloaded}
      >
        TILT MODE
      </button>
      
    </>
  );
};

export default TiltMode;